import React, { useState } from "react";
import Modal from "./projects/Modal";
import projet1 from "../assets/web.png";
import projet2 from "../assets/mlproject.gif";
import projet3 from "../assets/projet3.jpg";
import projet4 from "../assets/project002.jpg";
import { FaEye } from "react-icons/fa";
import devlogiSubImage1 from "../assets/qardylink.gif";
import poCSubImage2 from "../assets/PoC-DataDecintch.gif";

const projects = [
  {
    title: "Application web",
    image: projet1,
    subdescription:
      "Quelques projets d'applications web réalisés avec des diverses technologies modernes.",
    description:
      "Ces projets répondont  aux besoins spécifiques des utilisateurs et des entreprises, en offrant une interface intuitive, accessible depuis n’importe quel appareil connecté.",
    subprojects: [
      {
        name: "Benkko",
        description:
          "Une entreprise qui propose des services et produits de haute qualité...",
        urlWeb: "https://www.benkko.com",
        tech: ["React.js", "TypeScript", "CSS", "CI/CD avec GitHub Actions"],
      },
      {
        name: "Consultametrics",
        description:
          "ConsultaMetrics est une société consulting  basée à Chelles (France), spécialisée dans le développement de projets IT et la data science...",
        urlWeb: "https://www.consultametrics.fr",
        tech: ["React.js", "TypeScript", "CSS", "GitHub Actions(CI/CD)"],
      },
      {
        name: "Qardyl",
        description:
          "Basée à Bangui (Centrafrique), Qardyl est spécialisée dans les cartes de visite  digitale , conçues pour les particuliers et les entreprises.",
        urlWeb: "https://www.qardyl.com",
        tech: ["React.js", "TypeScript", "CSS", "Cloud AWS", "Fullstack"],
      },
    ],
  },
  {
    title: "Projets Data",
    image: projet2,
    subdescription:
      "Projets d'enquête et sondage - Analyse de données réalisés avec des technologies modernes.",
    description:
      "Ces projets revêtent une grande importance pour la stratégie data de nos clients...",
    subprojects: [
      {
        name: "Projet basé sur la science cognitive",
        description:
          "Ce projet exploite les principes de la science cognitive pour concevoir des enquêtes et des sondages...",
        tech: ["SQL", "Python", " Excel", "Power BI"],
      },
      {
        name: "Tableau  évolutif pour la valorisation des données",
        description:
          "Ce projet propose un tableau de bord interactif et évolutif conçu pour maximiser la valorisation des données d’entreprise...",
        tech: ["Python", "Cloud Google", "NoSQL.", "Grafana"],
      },
    ],
  },
  {
    title: "Développement logiciel",
    image: projet3,
    subdescription:
      "Projets de developpement logiciel realisés avec des technologies modernes par nos équipes.",
    description:
      "Ces projets respectent les normes de qualité et de sécurité les plus strictes de nos clients...",
    subprojects: [
      {
        name: "QardyLink",
        description:
          "Cette application desktop, développée pour l’environnement Windows, facilite la gestion des tags NFC...",
        subImage: devlogiSubImage1,
        tech: ["Java", "IntelliJ", "NFC", "JavaFX", "Maven"],
      },
    ],
  },
  {
    title: "Différents PoC",
    image: projet4,
    subdescription:
      "Quelques PoC réalisés et transférables à vos projets concrets.",
    description:
      "Ces PoC visent à démontrer la faisabilité et la valeur ajoutée de solutions innovantes...",
    subprojects: [
      {
        name: "Ministère du plan (Centrafrique): Plateforme de gestion des projets",
        description:
          "Cette plateforme de gestion des projets  est un outil numérique centralisé dédié au suivi...",
        urlWeb: "https://ministere-plan-projet.pages.dev/login",
        subImage: poCSubImage2,
        tech: ["React.js", "TypeScript", "CSS", "Cloud AWS", "Fullstack"],
      },
      {
        name: "SmartAgriculture",
        description:
          "PoC pour l’optimisation de l’irrigation intelligente dans l’agriculture urbaine.",
        tech: ["Python", "Influxdb", "Grafana", "Docker"],
      },
    ],
  },
];

const Projects = ({ id }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [zoom, setZoom] = useState(false);

  const handleOpenModal = (idx) => {
    setOpenIndex(idx);
    setZoom(false);
  };

  const handleCloseModal = () => {
    setOpenIndex(null);
    setZoom(false);
  };

  return (
    <section id={id} className="py-28 px-6 bg-[#F0F8FF]">
      <h1 className="text-3xl font-extrabold mb-12 text-center tracking-tight text-[#00171f]">
        Quelques projets réalisés
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 auto-rows-fr">
        {projects.map((project, index) => (
          <article
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 150}
            className="group rounded-lg shadow-lg border border-gray-300 bg-white flex flex-col overflow-hidden hover:shadow-2xl transition-shadow duration-400"
          >
            <div className="relative h-48 w-full overflow-hidden">
              <img
                src={project.image}
                alt={project.title}
                className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/70 to-transparent p-3">
                <h3 className="text-white text-lg font-semibold">{project.title}</h3>
                <p className="text-gray-300 text-sm">{project.subdescription}</p>
              </div>
            </div>
            <section className="p-5 flex flex-col flex-grow justify-between">
              <p className="text-gray-700 mb-4 text-sm leading-relaxed line-clamp-4">
                {project.description}
              </p>
              <button
                onClick={() => handleOpenModal(index)}
                aria-label={`En savoir plus sur ${project.title}`}
                className="self-start mt-auto px-5 py-2 bg-[#00df9a] text-[#00171f] font-semibold rounded hover:bg-[#00b87d] transition"
              >
                En savoir plus
              </button>
            </section>
          </article>
        ))}
      </div>

      {/* Modal for project details */}
       {openIndex !== null && (
        <Modal isOpen={openIndex !== null} onClose={handleCloseModal}>
          <div className="flex flex-col items-center w-full max-w-2xl mx-auto p-2">
            <img
              src={projects[openIndex].image}
              alt={projects[openIndex].title}
              className="h-48 w-full max-w-xs object-cover rounded mb-4"
            />
            <h3 className="text-2xl font-bold mb-2 text-center">
              {projects[openIndex].title}
            </h3>
            <p
              className={`text-gray-700 text-base transition-transform duration-300 cursor-zoom-in text-center ${
                zoom ? "scale-105" : ""
              }`}
              onClick={() => setZoom((z) => !z)}
              title="Cliquez pour zoomer"
            >
              {projects[openIndex].description}
            </p>
            <div className="w-full mt-4">
              <h4 className="font-semibold text-[#00171f] mb-2 text-center underline">
                Liste des projets déjà réalisés :
              </h4>
              <ul className="space-y-6">
                {projects[openIndex].subprojects.map((sub, idx) => (
                  <li
                    key={idx}
                    className="bg-gray-50 rounded p-3 shadow-sm flex flex-col "
                  >
                    <span className="block font-bold text-[#00df9a]">
                      {idx + 1}. {sub.name}
                    </span>
                    <span className="mt-2 block text-gray-700 text-sm ">
                      {sub.description}
                    </span>
                    {sub.subImage && (
                      <img
                        src={sub.subImage}
                        alt={sub.name}
                        className="h-36 w-full max-w-xs object-cover rounded my-3"
                      />
                    )}
                    <span className="mt-2 block text-gray-700 text-sm ">
                      {sub.urlWeb && (
                        <a
                          href={sub.urlWeb}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 hover:underline flex gap-1"
                        >
                          Visiter le site
                          <FaEye style={{ color: "gray", fontSize: "22px" }} />
                        </a>
                      )}
                    </span>
                    <div className="mt-4 flex flex-wrap gap-2 ">
                      {sub.tech.map((tech, i) => (
                        <span
                          key={i}
                          className="px-3 py-1 bg-[#00df9a]/10 text-[#00df9a] text-xs rounded-full"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="mt-6 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition-colors max-w-xs"
              onClick={handleCloseModal}
            >
              Fermer
            </button>
          </div>
        </Modal>
      )}
    
    </section>
  );
};

export default Projects;
